


































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AlpacaCard from '@/components/AlpacaCard.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import AInfo from '@/components/AInfo.vue';
import Boost from '@/components/Boost.vue';
import { getAlpacaInfo } from '@/backend/requests';
import { Wearable } from '@/backend/type';
import { alpaUnit } from '@/utils/unit';
import { isOwnerOf, getCurBlockNumber, crack, getAlpaca } from '@/utils/web3';
import { addressFormat } from '@/utils/unit';
import { EventBus } from '@/utils/EventBus';
import { format, intervalToDuration } from 'date-fns';
import { ROUTE_ADOPT, ROUTE_ALPACA, ROUTE_BREEDING } from '@/router';
import { secPerBlock } from '@/utils/constant';
import BigNumber from 'bignumber.js';

@Component({
  components: {
    AlpacaCard,
    AInfo,
    AlpacaBtn,
    Boost,
  },
})
export default class ScarfInfo extends Vue {
  @Prop({
    required: true,
  })
  public scarfID!: number;

  public scarf: Wearable | null = null;
  public isOwner: boolean = false;
  public loaded: boolean = false;
  public alpaInfoFromContract: any = null;

  get account() {
    return this.$store.getters.getAccount;
  }

  public async created() {
    this.getWearableInfo();
  }

  public async getWearableInfo() {
    const res = await getAlpacaInfo(this.scarfID, this.account);
    if (res) {
      this.scarf = res.data as any;
    }
    this.loaded = true;
  }

  public async getIsOwner() {
    this.isOwner = await isOwnerOf(this.account, this.scarfID);
  }

  public async getAlpacaInfoFromContract() {
    const info = await getAlpaca(Number(this.scarfID));
    if (info) {
      this.alpaInfoFromContract = info;
    }
  }

  public goTransfer() {
    if (!this.scarf) {
      return;
    }
    // EventBus.$emit('item-transfer',
    // {id: this.scarf.id, svg_url: this.scarf.svg_url,
    // state: this.scarf.state, bgColor: this.scarf.card_background_color}, 'wearable');
  }

  // public async getCurBlockNumber() {
  //   this.curBlockNumber = await getCurBlockNumber();
  // }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.getIsOwner();
      this.getWearableInfo();
    }
  }

  @Watch('alpacaID', {immediate: true})
  public onAlpacaID(val: string) {
    if (val) {
      this.loaded = false;
      this.getWearableInfo();
    }
  }
}
